import Consulta from "views/TableList/ConsultaCorte.jsx";

var dashRoutes = [
  {
    path: "/Corte/Procesos",
    name: "Procesos",
    icon: "nc-icon nc-briefcase-24",
    component: Consulta,
  },
  {
    redirect: true,
    path: "/",
    pathTo: "/Corte/Procesos",
    name: "Registro",
  },
];

export default dashRoutes;
